import {Injectable} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {SnackBarComponent} from '../components/snack-bar/snack-bar.component';

@Injectable({
  providedIn: 'root'
})
export class SnackBarService {

  constructor(private readonly snackBar: MatSnackBar) {
  }

  /**
   * @param message - message to be displayed in form of a translation key.
   * @param duration - duration in seconds.
   * @param className - optional class name to be added to the snackbar.
   * @param messageParams - optional interpolation params for the translation key.
   */
  open(message: string, duration: number, className: string = '', messageParams?: Record<string, unknown>) {
    return this.snackBar.openFromComponent(SnackBarComponent, {
      data: {
        message: message,
        messageParams: messageParams
      },
      panelClass: className,
      duration: duration * 1000
    });
  }
}
